import { useEffect, useRef, useState } from 'react';
import {
  IMPERSONATION_EXIT_MIN_MS,
  clearImpersonationExiting,
  consumeImpersonationReturn,
} from './impersonationExit';

export default function useImpersonationExitGate(adminReady) {
  const initialRef = useRef(null);
  if (initialRef.current === null) {
    initialRef.current = consumeImpersonationReturn();
  }

  const [active, setActive] = useState(() => Boolean(initialRef.current.active));
  const [minElapsed, setMinElapsed] = useState(() => {
    if (!initialRef.current.active) return true;
    return Date.now() - initialRef.current.startedAt >= IMPERSONATION_EXIT_MIN_MS;
  });

  useEffect(() => {
    if (!active || minElapsed) return undefined;
    const remaining = IMPERSONATION_EXIT_MIN_MS - (Date.now() - initialRef.current.startedAt);
    const timer = window.setTimeout(() => setMinElapsed(true), Math.max(0, remaining));
    return () => window.clearTimeout(timer);
  }, [active, minElapsed]);

  useEffect(() => {
    if (!active || !adminReady || !minElapsed) return;
    clearImpersonationExiting();
    setActive(false);
  }, [active, adminReady, minElapsed]);

  return active;
}
